import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LoginIcon from '@mui/icons-material/Login';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loading from 'components/Loading/Loading';
import { APP_TITLE } from 'constants/messages';
import { adminLogin } from 'store/actions';
import {
  selectErrorMsg,
  selectErrorStatus,
  selectLoading,
} from 'store/selectors/';
import { baselineTheme } from 'styles';

import {
  avatarStyle,
  elementStyle,
  loginBoxStyle,
  loginIconStyle,
} from './AdminLogin.style';

const AdminLogin = () => {
  const dispatch = useDispatch();

  const errorStatus = useSelector(selectErrorStatus);
  const errorMsg = useSelector(selectErrorMsg);
  const loading = useSelector(selectLoading);

  let [password, setPass] = React.useState('');

  const loginAsAdmin = () => {
    dispatch(adminLogin(password));
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <ThemeProvider theme={baselineTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box sx={loginBoxStyle}>
          <Avatar sx={avatarStyle}>
            <LockOutlinedIcon />
          </Avatar>

          <Typography variant="h5" sx={elementStyle}>
            {APP_TITLE} Admin
          </Typography>

          {errorStatus && <Alert severity="error">{errorMsg}</Alert>}

          <Box
            component="form"
            sx={elementStyle}
            onSubmit={() => {
              loginAsAdmin(password);
            }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              onChange={(event) => setPass(event.target.value)}
            />

            <Button type="submit" variant="contained" fullWidth>
              Log in <LoginIcon sx={loginIconStyle} />
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default AdminLogin;
